import React from 'react';
import PropTypes from 'prop-types';

import Spinner from 'react-svg-spinner';

class Button extends React.Component {
  timeoutRunning = false;

  constructor(props) {
    super(props);

    this.state = { ...this.resolveState(props), animate: true };
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ ...this.resolveState(props), animate: false
    }, () => {
      if (this.timeoutRunning) { return; }

      this.timeoutRunning = true;
      setTimeout(() => {
        this.setState({ animate: true }, () => this.timeoutRunning = false);
      }, 0); // Execute at end of the queue of the event loop
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (nextProps.selected !== this.state.active) || nextState.animate === true;
  }

  resolveState(props) {
    return {
      active: props.selected,
      label: props.label
    };
  }

  render () {
    const { disabled, showSpinner } = this.props;

    return (
      <div
        className={this.resolveClassName()}
        onClick={this.onClick.bind(this)}
        onMouseEnter={this.onMouseEnter.bind(this)}
        disabled={disabled}
      >

        <span className="button__content">{this.state.label}</span>
        { showSpinner === true && <Spinner /> }
      </div>
    );
  }

  resolveClassName() {
    let buttonClass = this.props.className !== '' ? this.props.className : ' button';

    if (this.state.active) { buttonClass += ' active'; }
    if (this.state.active || !this.state.animate) { buttonClass += ' no-anim'; }

    return buttonClass;
  }

  onClick() {
    if (this.props.disabled) { return; }

    this.props.onClick();
  }

  onMouseEnter() {
    if (!this.state.animate) {
      this.setState({ animate: true });
    }
  }
}

Button.defaultProps = {
  className: '',
  selected: false,
  odd: false,
  disabled: false,
  showSpinner: false
};

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  odd: PropTypes.bool,
  threeColumn: PropTypes.bool,
  showSpinner: PropTypes.bool
};

export default Button;
